import axios from "axios";

export const apiVision = axios.create({
  baseURL: import.meta.env.VITE_VISION_API,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    "x-api-key": import.meta.env.VITE_VISION_API_KEY || "",
  },
});
